import { useIntl } from 'react-intl';

import type { XingLogoVariant } from '@xing-com/xing-logo';
import { addParams } from '@xing-com/xing-tracking';

import { LogoSvg } from './logo-svg';
import { StyledLink } from './logo.styles';

const A11Y_LOGO_KEY = 'A11Y_LOGO';

export type LogoProps = {
  butterfly?: boolean;
  className?: string;
  homeLink?: string;
  dataQa?: string;
  dataTestId?: string;
  variant?: XingLogoVariant;
  size?: number;
};

const Logo: React.FC<LogoProps> = ({
  butterfly = false,
  className,
  homeLink = '/',
  dataQa,
  dataTestId,
  variant,
  size,
}) => {
  const intl = useIntl();
  const to = addParams(homeLink, {
    nwt_nav: 'header_logo',
    sc_o: 'navigation_header_logo',
  });

  return (
    <StyledLink
      {...(homeLink && { to })}
      title={intl.formatMessage({ id: A11Y_LOGO_KEY })}
      aria-label={intl.formatMessage({ id: A11Y_LOGO_KEY })}
      className={className}
      data-qa={dataQa}
      data-testid={dataTestId}
    >
      <LogoSvg butterfly={butterfly} variant={variant} size={size} />
    </StyledLink>
  );
};

export { Logo };
